// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1UEwr","name":"Header_name__3t562","birthday":"Header_birthday__3yJXj","skeleton":"Header_skeleton__3Vkqs"};